import React from 'react';
import {Grid,Box,Typography} from '@mui/material'

const BAUDetails = ({data}:any) => {
  return (
    <Grid container spacing={2}>
    <Grid item xs={12}>
      <Box display="flex" flexDirection="column" p={2} borderRadius={2} boxShadow={3} bgcolor="#f9f9f9">
        
        {[
          { label: 'شرح', value: data?.name },
          { label: 'مسئول', value: data?.responsibleName },
          { label: 'مقدار شروع', value: data?.startValue },
          { label: 'حد پایین', value: data?.lowerLimit },
          { label: 'حد بالا', value: data?.upperLimit },
          { label: 'توضیحات', value: data.orgDescription === null ? '' : data?.orgDescription }
        ].map((item, index) => (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
            p={1}
            bgcolor={index % 2 === 0 ? '#f0f8ff' : '#ffffff'}
            borderRadius={1}
            border="1px solid #00387C"
          >
            <Typography fontWeight={800} color="#00387C">
              {item.label}:
            </Typography>
            <Box 
              p={1}
            //   border="1px solid #00387C" 
              borderRadius={1} 
              bgcolor="#f9f9f9"
              display="flex"
              justifyContent="center"
              alignItems="center"
              minWidth="50px"
            >
              <Typography fontSize="16px" color="#555">
                {item.value}
              </Typography>
            </Box>
          </Box>
        ))}
  
      </Box>
    </Grid>
  </Grid>
  
  
  )
}

export default BAUDetails